import { type FC } from "react";
import * as styles from "./styles.css";

export const PrivateLabel: FC = () => <span className={styles.label}>非公開</span>;
